// extracted by mini-css-extract-plugin
export var content = "ProjectGalleryCard-module--content--513b2";
export var fadeInAnimation = "ProjectGalleryCard-module--fadeInAnimation--56457";
export var hint = "ProjectGalleryCard-module--hint--91c57";
export var hintLabel = "ProjectGalleryCard-module--hintLabel--5474a";
export var hintText = "ProjectGalleryCard-module--hintText--bce6c";
export var img = "ProjectGalleryCard-module--img--11f55";
export var item = "ProjectGalleryCard-module--item--d0f20";
export var logo = "ProjectGalleryCard-module--logo--75429";
export var mdWidth = "ProjectGalleryCard-module--mdWidth--f672d";
export var nda = "ProjectGalleryCard-module--nda--b93d9";
export var ndaIcon = "ProjectGalleryCard-module--ndaIcon--729ff";
export var ndaLogoText = "ProjectGalleryCard-module--ndaLogoText--d6bc9";
export var picture = "ProjectGalleryCard-module--picture--7ce08";
export var smWidth = "ProjectGalleryCard-module--smWidth--a1f68";
export var title = "ProjectGalleryCard-module--title--f49ae";
export var titleWrapper = "ProjectGalleryCard-module--titleWrapper--12de6";
export var video = "ProjectGalleryCard-module--video--41aa8";
export var videoWrapper = "ProjectGalleryCard-module--videoWrapper--7f21e";